import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import type { AppointmentBookingService } from '../../types';

type ServiceContextI = {
  services: AppointmentBookingService[];
  currentService: AppointmentBookingService | undefined;
  setCurrentService: (service?: AppointmentBookingService) => void;
};

const ServicesContext = createContext<ServiceContextI | null>(null);

export function ServicesProvider({ children }: PropsWithChildren) {
  const { services = [] } = useSettings();
  const [currentService, setCurrentService] = useState<
    AppointmentBookingService | undefined
  >();

  const visibleServices = useMemo(() => {
    return services.filter(({ visible }) => visible !== false);
  }, [services]);

  const value = useMemo(
    () => ({
      services: visibleServices,
      currentService,
      setCurrentService
    }),
    [visibleServices, currentService]
  );

  return (
    <ServicesContext.Provider value={value}>
      {children}
    </ServicesContext.Provider>
  );
}

export function useServices() {
  const context = useContext(ServicesContext);

  if (context === null) {
    throw new Error(`useServices should be used within ServicesProvider`);
  }

  return context;
}
